export default __webpack_public_path__ + "static/media/icon_user_green.a9c815e5.svg";